import { API_URL, jwtToken } from "../../../context/appContext";
export default async function terminateServer() {
    return fetch(`${API_URL}/api/terminate_server`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
